import React from "react";
import { Paper, Tabs, Center, Button, Divider } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { Text, Title, Stack } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import "./InitialQuoteForm.scss";
import { VINForm } from "../VINForm/VINForm";
import { LicensePlateForm } from "../LicensePlateForm/LicensePlateForm";
import { useContext } from "react";
import { GlobalContext } from "../../context/GlobalContext";
import { defaultContext } from "../../models/constants/defaultContext";
import { loginRequest } from "../../authConfig";
import { useMsal } from "@azure/msal-react";

export const InitialQuoteForm = (props) => {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const handleLoginRedirect = () => {
    let contextJSON = context;
    contextJSON.completed_pages.final_estimated_quote = true;
    localStorage.setItem("context", JSON.stringify(contextJSON));
    instance.loginRedirect(loginRequest).catch((error) => {
      console.log(error);
    });
  };

  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width: 1024px)", true, {
    getInitialValueInEffect: false,
  });
  const isNarrow = useMediaQuery("(max-width: 450px)", true, {
    getInitialValueInEffect: false,
  });
  const { context, setContext } = useContext(GlobalContext);
  
  // Year/Make/Model quoting was removed (AB#5798) - legacy ?year=&make=&model=
  // links and Y/M/M-only context now land on License Plate.
  const getDefaultTab = () => {
    if (context.vehicle_data.vin || props.vin) {
      return "vin";
    } else {
      return "license-plate";
    }
  };

  const handleTabChange = () => {
    setContext({
      ...defaultContext,
      quote_form_data: context.quote_form_data,
    });
  };

  return (
    <Paper
      bg={"white"}
      p={isMobile ? "24px 6%" : "40px"}
      radius={8}
      id="start_quote"
      miw={isMobile ? null : "500px"}
    >
      <Stack gap={24}>
        <Title ff="Crimson Text" fz={40} fw={600} lh={"125%"}>
          {t("your-vehicle")}
        </Title>
        <Text ff={"Montserrat"} fz={18} fw={400} lh={"160%"} c={"#636363"}>
          {t("enter-vehicle-information")}
        </Text>
        <Tabs
          color="#ff671d"
          defaultValue={getDefaultTab}
          onChange={handleTabChange}
          styles={{
            list: {
              display: "flex",
              flexWrap: "nowrap"
            }
          }}
        >
          <Tabs.List grow justify="center" mb="24px" ff="Montserrat" fw={600}>
            <Tabs.Tab value="license-plate">
              <Text ff="Montserrat" fw="600" fz={isNarrow ? 16 : 18}>
                {t("license-plate")}
              </Text>
            </Tabs.Tab>
            <Tabs.Tab value="vin">
              <Text ff="Montserrat" fw="600" fz={isNarrow ? 16 : 18}>
                {t("vin")}
              </Text>
            </Tabs.Tab>
          </Tabs.List>
          <Tabs.Panel value="license-plate">
            <LicensePlateForm />
          </Tabs.Panel>
          <Tabs.Panel value="vin">
            <VINForm vin={props.vin} mileage={props.mileage} />
          </Tabs.Panel>
        </Tabs>
      </Stack>
      <Divider label={<Text fz={16} fw={400} c={"#636363"}>{t("or")}</Text>} labelPosition="center" styles={{ root: { marginTop: "24px" } }}/>
      <Text ff={"Montserrat"} fz={18} fw={400} lh={"160%"} c={"#636363"} mt={"24px"}>
        {t("already-a-guest")}
      </Text>
      <Center>
        <Button
          variant="outline"
          color="#FF671D"
          className="button"
          styles={{
            root: {
              marginTop: "12px",
            },
          }}
          onClick={() => handleLoginRedirect()}
        >
          {activeAccount ? t("select-vehicle") : t("sign-in")}
        </Button>
      </Center>
    </Paper>
  );
};
